module.exports = __webpack_public_path__ + "img/rumor.005d3f33.png";